
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("bhDw8", function(module, exports) {

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $hGV5v = parcelRequire("hGV5v");

/* overflow-container.tsx generated by @compiled/babel-plugin v0.36.1 */ 


parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");

const $82a805d96531e510$var$overflowContainerStyles = null; /**
                                       * __Overflow container__
                                       */ 
const $82a805d96531e510$var$OverflowContainer = ({ isSingleLine: isSingleLine, ...props })=>/*#__PURE__*/ (0, $l998X.jsx)("span" // eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
    , {
        ...props,
        className: (0, $gMc0m.default)([
            isSingleLine && "_1reo15vq _18m915vq _1bto1l2s _o5721q9c"
        ])
    });
var $82a805d96531e510$export$2e2bcd8739ae039 = $82a805d96531e510$var$OverflowContainer;



var $biy2a = parcelRequire("biy2a");

const $190c9f1c6e050fc4$var$CellComponent = ({ children: children, singleLine: singleLine, indentLevel: indentLevel, width: width, className: className, ...props })=>/*#__PURE__*/ (0, $l998X.jsx)((0, $hGV5v.default), {
        indent: indentLevel ? `calc(${"var(--ds-space-300, 25px)"} * ${indentLevel})` : undefined,
        width: width,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: className,
        ...props,
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $82a805d96531e510$export$2e2bcd8739ae039), {
            isSingleLine: singleLine,
            children: children
        })
    });
const $190c9f1c6e050fc4$var$Cell = (0, $biy2a.default)($190c9f1c6e050fc4$var$CellComponent);
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$190c9f1c6e050fc4$export$2e2bcd8739ae039 = $190c9f1c6e050fc4$var$Cell;
module.exports["default"] = $190c9f1c6e050fc4$export$2e2bcd8739ae039;

});

parcelRegister("dlke8", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $bhDw8 = parcelRequire("bhDw8");


var $CdIqF = parcelRequire("CdIqF");


var $e7vmR = parcelRequire("e7vmR");


var $jnRoq = parcelRequire("jnRoq");


var $60KKo = parcelRequire("60KKo");


var $39F3L = parcelRequire("39F3L");

const $7c831e11b7f14d81$var$emptyColumnWidths = [];
function $7c831e11b7f14d81$var$TableTree({ children: children, columns: columns, columnWidths: defaultColumnWidths = $7c831e11b7f14d81$var$emptyColumnWidths, headers: headers, shouldExpandOnClick: shouldExpandOnClick, items: items, mainColumnForExpandCollapseLabel: mainColumnForExpandCollapseLabel, label: label, referencedLabel: referencedLabel }) {
    const [columnWidths, setColumnWidths] = (0, $42omo.useState)(defaultColumnWidths);
    const setColumnWidth = (0, $42omo.useCallback)((columnIndex, width)=>{
        if (width === columnWidths[columnIndex]) return;
        setColumnWidths((columnWidths)=>{
            const newColumnWidths = [
                ...columnWidths
            ];
            newColumnWidths[columnIndex] = width;
            return newColumnWidths;
        });
    }, [
        columnWidths
    ]);
    const getColumnWidth = (0, $42omo.useCallback)((columnIndex)=>{
        return columnWidths[columnIndex] || null;
    }, [
        columnWidths
    ]);
    const contextValue = (0, $42omo.useMemo)(()=>({
            setColumnWidth: setColumnWidth,
            getColumnWidth: getColumnWidth
        }), [
        setColumnWidth,
        getColumnWidth
    ]);
    const heads = headers && /*#__PURE__*/ (0, $l998X.jsx)((0, $e7vmR.default), {
        children: headers.map((header, index)=>/*#__PURE__*/ (0, $l998X.jsx)((0, $CdIqF.default), {
                columnIndex: index,
                width: columnWidths[index],
                children: header
            }, index))
    });
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $jnRoq.TableTreeContext).Provider, {
        value: contextValue,
        children: /*#__PURE__*/ (0, $l998X.jsxs)("div", {
            role: "treegrid",
            "aria-readonly": true,
            "aria-label": label,
            "aria-labelledby": referencedLabel,
            children: [
                heads,
                columns && items && /*#__PURE__*/ (0, $l998X.jsx)((0, $39F3L.default), {
                    items: items,
                    render: ({ id: id, children: children, content: content })=>/*#__PURE__*/ (0, $l998X.jsx)((0, $60KKo.default), {
                            itemId: id,
                            items: children,
                            hasChildren: !!children && children.length > 0,
                            shouldExpandOnClick: shouldExpandOnClick,
                            mainColumnForExpandCollapseLabel: mainColumnForExpandCollapseLabel,
                            children: columns.map((CellContent, index)=>{
                                return /*#__PURE__*/ (0, $l998X.jsx)((0, $bhDw8.default), {
                                    columnIndex: index,
                                    width: columnWidths[index],
                                    children: /*#__PURE__*/ (0, $l998X.jsx)(CellContent, {
                                        ...content
                                    })
                                }, `cell-${index}`);
                            })
                        })
                }),
                children
            ]
        })
    });
}
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$7c831e11b7f14d81$export$2e2bcd8739ae039 = $7c831e11b7f14d81$var$TableTree;
module.exports["default"] = $7c831e11b7f14d81$export$2e2bcd8739ae039;

});

parcelRegister("CdIqF", function(module, exports) {
/* header.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $hGV5v = parcelRequire("hGV5v");


var $biy2a = parcelRequire("biy2a");

const $e59bb37d5d9bf960$var$headerStyles = null; /**
                            * This is hard-coded here because our actual <Header /> has no typings
                            * for its props.
                            *
                            * Adding types for real *might* break things so will need a little care.
                            *
                            * Defining it here for now lets us provide *something* without much headache.
                            */ 
const $e59bb37d5d9bf960$var$HeaderComponent = ({ width: width, children: children, onClick: onClick, id: id, role: role = 'columnheader' })=>{
    // TODO: Determine whether proper `th` elements can be used instead of
    // roles (DSP-11588)
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $hGV5v.default), {
        role: role,
        width: width,
        id: id,
        onClick: onClick,
        className: (0, $gMc0m.default)([
            "_11c8dcr7 _syaz1gjq _k48pmoej"
        ]),
        children: children
    });
};
const $e59bb37d5d9bf960$var$Header = (0, $biy2a.default)($e59bb37d5d9bf960$var$HeaderComponent); // eslint-disable-next-line @repo/internal/react/require-jsdoc
var $e59bb37d5d9bf960$export$2e2bcd8739ae039 = $e59bb37d5d9bf960$var$Header;
module.exports["default"] = $e59bb37d5d9bf960$export$2e2bcd8739ae039;

});

parcelRegister("e7vmR", function(module, exports) {
/* headers.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");

/* eslint-disable @repo/internal/react/no-clone-element */ const $ec101d5fa614c2d8$var$containerStyles = null;
const $ec101d5fa614c2d8$var$Headers = ({ children: children })=>/*#__PURE__*/ (0, $l998X.jsx)("div", {
        role: "row",
        className: (0, $gMc0m.default)([
            "_179r1nk0 _1e0c1txw"
        ]),
        children: (0, $42omo.Children).map(children, (header, index)=>/*#__PURE__*/ (0, $42omo.cloneElement)(header, {
                key: index,
                columnIndex: index
            }))
    });
var $ec101d5fa614c2d8$export$2e2bcd8739ae039 = $ec101d5fa614c2d8$var$Headers;
module.exports["default"] = $ec101d5fa614c2d8$export$2e2bcd8739ae039;

});

parcelRegister("60KKo", function(module, exports) {
/* row.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $gMc0m = parcelRequire("gMc0m");


var $42omo = parcelRequire("42omo");


var $gxtzC = parcelRequire("gxtzC");


var $7UIkA = parcelRequire("7UIkA");

/* eslint-disable @repo/internal/react/consistent-props-definitions */ 


parcelRequire("42omo");


var $1qfLF = parcelRequire("1qfLF");


var $ee7An = parcelRequire("ee7An");


var $7kzZ3 = parcelRequire("7kzZ3");


var $15HFc = parcelRequire("15HFc");


var $9RYz9 = parcelRequire("9RYz9");

/**
 * Internal chevron component.
 */ const $61acca535b08ab26$var$Chevron = ({ isExpanded: isExpanded, ariaControls: ariaControls, collapseLabel: collapseLabel = 'Collapse', expandLabel: expandLabel = 'Expand', rowId: rowId, extendedLabel: extendedLabel, onExpandToggle: onExpandToggle = (0, $ee7An.default) })=>{
    const getLabel = (defaultLabel)=>extendedLabel ? `${defaultLabel} ${extendedLabel} row` : `${defaultLabel} row ${rowId}`;
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $9RYz9.ChevronContainer), {
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $1qfLF.default), {
            appearance: "subtle",
            onClick: onExpandToggle,
            spacing: "compact",
            icon: (iconProps)=>isExpanded ? /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($7kzZ3))), {
                    ...iconProps,
                    size: "small"
                }) : /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($15HFc))), {
                    ...iconProps,
                    size: "small"
                }),
            "aria-controls": isExpanded ? ariaControls : undefined,
            label: isExpanded ? getLabel(collapseLabel) : getLabel(expandLabel)
        })
    });
};
var $61acca535b08ab26$export$2e2bcd8739ae039 = $61acca535b08ab26$var$Chevron;





const $14277c44070f59c8$var$treeRowClickableStyles = null;
const $14277c44070f59c8$var$getExtendedLabel = (cellContent, cellIndex, mainColumnForExpandCollapseLabel)=>{
    /**
   * First condition - when we pass data via `items` property in `<TableTree />`
   * Second condition - when we pass data via `<Rows />` as children in `<TableTree />`.
   */ if (cellContent.hasOwnProperty('props')) return cellContent?.props[mainColumnForExpandCollapseLabel?.toLowerCase()];
    else if (cellIndex === mainColumnForExpandCollapseLabel) return cellContent;
    return undefined;
};
function $14277c44070f59c8$var$Row({ shouldExpandOnClick: shouldExpandOnClick, hasChildren: hasChildren, depth: depth, renderChildren: renderChildren, isDefaultExpanded: isDefaultExpanded, data: data, onExpand: providedOnExpand, onCollapse: providedOnCollapse, mainColumnForExpandCollapseLabel: mainColumnForExpandCollapseLabel, expandLabel: expandLabel, collapseLabel: collapseLabel, itemId: itemId, children: children, isExpanded: isProvidedExpanded }) {
    const [isExpandedState, setIsExpandedState] = (0, $42omo.useState)(isDefaultExpanded || false);
    (0, $42omo.useEffect)(()=>{
        if (isProvidedExpanded === undefined && isDefaultExpanded !== undefined) setIsExpandedState(isDefaultExpanded);
    }, [
        isDefaultExpanded,
        isProvidedExpanded
    ]);
    const onExpand = (0, $gxtzC.usePlatformLeafEventHandler)({
        fn: (value)=>providedOnExpand && providedOnExpand(value),
        action: 'expanded',
        actionSubject: 'tableTree',
        componentName: 'row',
        packageName: "platform-pkg",
        packageVersion: "0.0.0-use.local"
    });
    const onCollapse = (0, $gxtzC.usePlatformLeafEventHandler)({
        fn: (value)=>providedOnCollapse && providedOnCollapse(value),
        action: 'collapsed',
        actionSubject: 'tableTree',
        componentName: 'row',
        packageName: "platform-pkg",
        packageVersion: "0.0.0-use.local"
    }); /**
       * This ensures a user won't trigger a click event and expand the accordion
       * when making a text selection.
       */ 
    const onClickHandler = (e)=>{
        const selection = window.getSelection()?.toString() || '';
        if (selection?.length === 0) onExpandToggle(e);
    };
    const onExpandStateChange = (isExpanded)=>{
        if (data) {
            if (isExpanded && onExpand) onExpand(data);
            else if (!isExpanded && onCollapse) onCollapse(data);
        }
    };
    const onExpandToggle = (e)=>{
        e.stopPropagation();
        if (isProvidedExpanded !== undefined) onExpandStateChange(!isProvidedExpanded);
        else setIsExpandedState((prevState)=>{
            onExpandStateChange(!prevState);
            return !prevState;
        });
    };
    const renderCell = (cell, cellIndex)=>{
        const isFirstCell = cellIndex === 0;
        const indentLevel = isFirstCell ? depth : 0;
        let cellContent = cell.props.children || [];
        const extendedLabel = $14277c44070f59c8$var$getExtendedLabel(cellContent, cellIndex, mainColumnForExpandCollapseLabel);
        if (isFirstCell && hasChildren) cellContent = [
            /*#__PURE__*/ (0, $l998X.jsx)((0, $61acca535b08ab26$export$2e2bcd8739ae039), {
                expandLabel: expandLabel,
                collapseLabel: collapseLabel,
                extendedLabel: extendedLabel,
                isExpanded: isProvidedExpanded !== undefined ? isProvidedExpanded : isExpandedState,
                onExpandToggle: onExpandToggle,
                ariaControls: !!itemId ? (0, $7UIkA.default)(itemId) : undefined,
                rowId: !!itemId ? itemId : ''
            }, "chevron")
        ].concat(cellContent);
         // eslint-disable-next-line @repo/internal/react/no-clone-element
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).cloneElement(cell, {
            key: cellIndex,
            columnIndex: cellIndex,
            indentLevel: indentLevel
        }, cellContent);
    };
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $42omo.Fragment), {
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)((0, $9RYz9.TreeRowContainer), {
                onClick: hasChildren && shouldExpandOnClick ? onClickHandler : undefined,
                "aria-expanded": hasChildren ? isExpandedState : undefined,
                "aria-level": depth ? depth : undefined,
                className: (0, $gMc0m.default)([
                    hasChildren && shouldExpandOnClick && "_80omtlke"
                ]),
                children: (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Children.map(children, (cell, index)=>renderCell(cell, index))
            }),
            hasChildren && (isProvidedExpanded !== undefined ? isProvidedExpanded : isExpandedState) && renderChildren && renderChildren()
        ]
    });
}
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$14277c44070f59c8$export$2e2bcd8739ae039 = $14277c44070f59c8$var$Row;
module.exports["default"] = $14277c44070f59c8$export$2e2bcd8739ae039;

});

parcelRegister("39F3L", function(module, exports) {

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");





var $42omo = parcelRequire("42omo");

/* eslint-disable @repo/internal/react/no-clone-element */ 






var $7UIkA = parcelRequire("7UIkA");


/**
 * __Item__
 * Internal item component.
 */ function $9e4e8f7b33065b00$var$Item({ depth: depth = 0, data: data, render: render, loadingLabel: loadingLabel }) {
    const renderedRow = render(data);
    if (!renderedRow) return null;
    // itemId exists on RowProps, but not on RowsProps
    const itemId = 'itemId' in renderedRow.props ? renderedRow.props.itemId : undefined;
    const items = renderedRow.props.items;
    return /*#__PURE__*/ (0, $42omo.cloneElement)(renderedRow, {
        depth: depth,
        data: data,
        loadingLabel: loadingLabel,
        renderChildren: ()=>/*#__PURE__*/ (0, $l998X.jsx)("div", {
                id: !!itemId ? (0, $7UIkA.default)(itemId) : undefined,
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $8412f75e2074fa42$export$2e2bcd8739ae039), {
                    depth: depth,
                    items: items,
                    render: render,
                    loadingLabel: loadingLabel
                })
            })
    });
}
var $9e4e8f7b33065b00$export$2e2bcd8739ae039 = $9e4e8f7b33065b00$var$Item;









var $9hlns = parcelRequire("9hlns");


var $hGV5v = parcelRequire("hGV5v");


var $9RYz9 = parcelRequire("9RYz9");

const $66ac5266f9348afd$var$LoaderItem = ({ depth: depth = 1, loadingLabel: loadingLabel, isCompleting: isCompleting, onComplete: onComplete })=>{
    const [phase, setPhase] = (0, $42omo.useState)('loading');
    (0, $42omo.useEffect)(()=>{
        if (phase === 'loading' && isCompleting) setPhase(()=>{
            onComplete();
            return 'complete';
        });
    }, [
        isCompleting,
        onComplete,
        phase
    ]);
    return phase === 'loading' ? /*#__PURE__*/ (0, $l998X.jsx)((0, $9RYz9.TreeRowContainer), {
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $hGV5v.default), {
            indent: `calc(${"var(--ds-space-300, 25px)"} * ${depth})`,
            width: "100%",
            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $9RYz9.LoaderItemContainer), {
                isRoot: depth === 1,
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $9hlns.default), {
                    size: "small",
                    testId: "table-tree-spinner",
                    label: loadingLabel
                })
            })
        })
    }) : null;
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$66ac5266f9348afd$export$2e2bcd8739ae039 = $66ac5266f9348afd$var$LoaderItem;


function $8412f75e2074fa42$var$Items({ depth: depth = 0, items: items, loadingLabel: loadingLabel, render: render }) {
    const [isLoaderShown, setIsLoaderShown] = (0, $42omo.useState)(false);
    const handleLoaderComplete = ()=>setIsLoaderShown(false);
    return !items || isLoaderShown ? /*#__PURE__*/ (0, $l998X.jsx)((0, $66ac5266f9348afd$export$2e2bcd8739ae039), {
        isCompleting: !!(items && items.length),
        onComplete: handleLoaderComplete,
        depth: depth + 1,
        loadingLabel: loadingLabel
    }) : /*#__PURE__*/ (0, $l998X.jsx)((0, $l998X.Fragment), {
        children: items.map((data)=>/*#__PURE__*/ (0, $l998X.jsx)((0, $9e4e8f7b33065b00$export$2e2bcd8739ae039), {
                data: data,
                depth: depth + 1,
                render: render,
                loadingLabel: loadingLabel
            }, data.id))
    });
}
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$8412f75e2074fa42$export$2e2bcd8739ae039 = $8412f75e2074fa42$var$Items;


function $db7bc61115011078$var$Rows({ items: items, render: render, loadingLabel: loadingLabel = 'Loading' }) {
    return /*#__PURE__*/ (0, $l998X.jsx)("div", {
        role: "rowgroup",
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $8412f75e2074fa42$export$2e2bcd8739ae039), {
            items: items,
            loadingLabel: loadingLabel,
            render: render
        })
    });
}
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$db7bc61115011078$export$2e2bcd8739ae039 = $db7bc61115011078$var$Rows;
module.exports["default"] = $db7bc61115011078$export$2e2bcd8739ae039;

});

parcelRegister("jnRoq", function(module, exports) {

var $42omo = parcelRequire("42omo");

const $e33ac37582775330$export$662c2d348d8b71af = /*#__PURE__*/ (0, $42omo.createContext)({
    setColumnWidth: ()=>{},
    getColumnWidth: ()=>null
});
module.exports["TableTreeContext"] = $e33ac37582775330$export$662c2d348d8b71af;

});

parcelRegister("hGV5v", function(module, exports) {
/* common-cell.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");

const $11a85f091f538422$var$commonStyles = null;
const $11a85f091f538422$var$CommonCell = ({ indent: indent, width: width, className: className, ...props })=>/*#__PURE__*/ (0, $l998X.jsx)("div", {
        role: "gridcell" // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        ,
        className: (0, $gMc0m.default)([
            "_1yt412f9 _11c82smr _1e0c1txw _vchhusvi _1tke1ylp _kqswh2mm _4cvr1h6o _syaz1fxt _ct361wug _1nmz1hna",
            className
        ]),
        ...props,
        style: {
            '--indent': indent,
            width: width
        }
    });
var $11a85f091f538422$export$2e2bcd8739ae039 = $11a85f091f538422$var$CommonCell;
module.exports["default"] = $11a85f091f538422$export$2e2bcd8739ae039;

});

parcelRegister("biy2a", function(module, exports) {
$parcel$export(module.exports, "default", () => $0c57c83e4700bd55$export$2e2bcd8739ae039);

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $jnRoq = parcelRequire("jnRoq");

function $0c57c83e4700bd55$export$2e2bcd8739ae039(Cell) {
    return (props)=>{
        const { setColumnWidth: setColumnWidth, getColumnWidth: getColumnWidth } = (0, $42omo.useContext)((0, $jnRoq.TableTreeContext));
        const { width: width, columnIndex: columnIndex, ...other } = props;
        (0, $42omo.useEffect)(()=>{
            if (width !== undefined && columnIndex !== undefined) setColumnWidth(columnIndex, width);
        }, [
            width,
            columnIndex,
            setColumnWidth
        ]);
        let columnWidth;
        if (width !== null && width !== undefined) columnWidth = width;
        else if (columnIndex !== undefined) columnWidth = getColumnWidth(columnIndex);
        return /*#__PURE__*/ (0, $l998X.jsx)(Cell, {
            width: columnWidth,
            ...other
        });
    };
}

});

parcelRegister("7UIkA", function(module, exports) {
$parcel$export(module.exports, "default", () => $a56c6ac249467f90$export$2e2bcd8739ae039);
function $a56c6ac249467f90$export$2e2bcd8739ae039(id) {
    return `tabletreeitem-${id}`.replace(/[^-_a-zA-Z0-9]/g, '');
}

});

parcelRegister("9RYz9", function(module, exports) {
/* styled.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");

const $c100acdd4974c12b$var$treeRowContainerStyles = null; /**
                                      * __Tree row container__
                                      */ 
const $c100acdd4974c12b$export$802d2031792f9e4 = (props)=>/*#__PURE__*/ (0, $l998X.jsx)("div", {
        role: "row" // eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
        ,
        ...props,
        className: (0, $gMc0m.default)([
            "_179r7r9e _1e0c1txw"
        ])
    });
const $c100acdd4974c12b$var$commonCellElementStyles = null;
const $c100acdd4974c12b$var$commonChevronContainerStyles = null;
const $c100acdd4974c12b$export$f25bd028f55b3d30 = (props)=>/*#__PURE__*/ (0, $l998X.jsx)("span" // eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
    , {
        ...props,
        className: (0, $gMc0m.default)([
            "_1e0c1txw _kqswstnw _4cvr1h6o _ahbq1lmg",
            "_1pfhj39m"
        ])
    });
const $c100acdd4974c12b$var$loadingItemContainerStyles = null;
const $c100acdd4974c12b$var$paddingLeftStyles = null;
const $c100acdd4974c12b$export$94ae573de7227397 = ({ isRoot: isRoot, ...props })=>/*#__PURE__*/ (0, $l998X.jsx)("span" // eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
    , {
        ...props,
        className: (0, $gMc0m.default)([
            "_1e0c1txw _kqswstnw _4cvr1h6o _ahbq1lmg",
            "_1bsb1osq",
            isRoot && "_bozg1ssb"
        ])
    });
module.exports["TreeRowContainer"] = $c100acdd4974c12b$export$802d2031792f9e4;
module.exports["ChevronContainer"] = $c100acdd4974c12b$export$f25bd028f55b3d30;
module.exports["LoaderItemContainer"] = $c100acdd4974c12b$export$94ae573de7227397;

});


//# sourceMappingURL=UnarchivePagesLoader.9ffcf1a8.js.map
